import { render, staticRenderFns } from "./OnboardingTrialFinal.vue?vue&type=template&id=87ba09e2&scoped=true&"
import script from "./OnboardingTrialFinal.vue?vue&type=script&lang=js&"
export * from "./OnboardingTrialFinal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTrialFinal.vue?vue&type=style&index=0&id=87ba09e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ba09e2",
  null
  
)

export default component.exports